import {Link, useNavigate} from 'react-router-dom'
import {Plus, Video} from 'lucide-react'
import {Button} from '@/shared/ui'
import {AppHeader} from '@/widgets/app-header'
import {useAuthStore} from '@/features/auth'
import {cn} from '@/shared/lib'
import {generateRoomId} from '../lib/roomId'

export const CreateRoomPage = () => {
  const navigate = useNavigate()
  const isAuthenticated = useAuthStore(s => s.isAuthenticated)

  const handleCreateRoom = () => {
    const roomId = generateRoomId()
    navigate(`/room/${roomId}`)
  }

  return (
    <div className="relative flex min-h-screen flex-col overflow-hidden">
      <AppHeader />
      <div className="relative flex flex-1 items-center justify-center px-4 py-8 sm:px-8 sm:py-0">
        <div className="w-full max-w-[380px] animate-in fade-in slide-in-from-bottom-3 duration-500">
          <div
            className={cn(
              'rounded-[20px] border border-primary/15 bg-card/80 p-6 sm:p-8',
              'backdrop-blur-[20px] transition-all duration-300',
              'shadow-(--shadow-card)',
            )}
          >
            <div className="flex flex-col gap-6">
              <div className="flex flex-col gap-3">
                <Button onClick={handleCreateRoom} size="lg" className="w-full">
                  <Plus className="size-5" />
                  Создать комнату
                </Button>
              </div>
              {!isAuthenticated && (
                <>
                  <div className="border-t border-border/60" />
                  <div className="flex flex-col items-center gap-3">
                    <div className="flex flex-wrap items-center justify-center gap-2">
                      <Button variant="outline" size="sm" asChild>
                        <Link to="/login">Войти</Link>
                      </Button>
                      <Button variant="ghost" size="sm" asChild>
                        <Link to="/register">Зарегистрироваться</Link>
                      </Button>
                    </div>
                    <p className="flex items-center gap-2 text-xs text-muted-foreground pt-2">
                      <Video className="size-4 shrink-0" />
                      Регистрация позволяет делать записи созвонов
                    </p>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
